// extracted by mini-css-extract-plugin
export default {"container":"Tariffs_container__X9Sc6","textContainer":"Tariffs_textContainer__z9Fp6","mainText":"Tariffs_mainText__Q8wfo","secondText":"Tariffs_secondText__Zkp6D"};